"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyReceivedData = exports.verifyFlag = exports.verifyJSX = void 0;
let computedStyles = {
    getPropertyValue() {
        return null;
    },
};
if (globalThis.window) {
    computedStyles = globalThis.window.getComputedStyle(globalThis.window.document.documentElement);
}
function verifyJSX() {
    return <react-native-css-interop-jsx-pragma-check /> === true;
}
exports.verifyJSX = verifyJSX;
function verifyFlag(name, value = "true") {
    return globalThis.window
        ? computedStyles.getPropertyValue(name ? `--css-interop-${name}` : "--css-interop") === value
        : true;
}
exports.verifyFlag = verifyFlag;
function verifyReceivedData() {
    return verifyFlag();
}
exports.verifyReceivedData = verifyReceivedData;
//# sourceMappingURL=doctor.js.map